import { SplitLibrarySplitKind } from "@redotech/redo-model/checkouts/splits/split-library";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getSplitLibrarySplits = {
  name: "getSplitLibrarySplits" as const,
  input: z.null(),
  output: z.object({
    splits: z.array(
      z.object({
        kind: createEnum(SplitLibrarySplitKind),
        title: z.string(),
        description: z.string(),
      }),
    ),
  }),
};
